import ChatApi from "./ChatApi";

export default ChatApi;
